import { unwrap, withSignal } from "@nexxt/api-client";
import { filterQuery } from "@nexxt/app-kit";
import type { PartyClient } from "@nexxt/party-ui";
import { api } from "./api";

// The users and directory screens on gateway-atelier (ADR-173): one call per operation, input and answer of its
// contract. The gateway has the operations of an organization's own administrator alone (ExternalPartyService,
// ADR-172), and the domain keeps every one of them to the organization of the user.

const { party } = api;
const user = party.users[":userId"];
const contact = party.contacts[":contactId"];

export const partyClient: PartyClient = {
  listUsers: (input, signal) => unwrap(party.users.$get({ query: filterQuery(input) }, withSignal(signal))),
  getUserOptions: (_, signal) => unwrap(party["user-options"].$get({}, withSignal(signal))),
  getUser: (param, signal) => unwrap(user.$get({ param }, withSignal(signal))),
  createUser: (json) => unwrap(party.users.$post({ json })),
  updateUser: ({ userId, ...json }) => unwrap(user.$patch({ param: { userId }, json })),
  setUserRoles: ({ userId, ...json }) => unwrap(user.roles.$put({ param: { userId }, json })),
  changeUsersRoles: (json) => unwrap(party["user-role-changes"].$post({ json })),
  blockUser: ({ userId, version }) => unwrap(user.block.$post({ param: { userId }, json: { version } })),
  unblockUser: ({ userId, version }) => unwrap(user.unblock.$post({ param: { userId }, json: { version } })),
  disableUser: ({ userId, version }) => unwrap(user.disable.$post({ param: { userId }, json: { version } })),
  enableUser: ({ userId, version }) => unwrap(user.enable.$post({ param: { userId }, json: { version } })),
  listContacts: (input, signal) => unwrap(party.contacts.$get({ query: filterQuery(input) }, withSignal(signal))),
  createContact: (json) => unwrap(party.contacts.$post({ json })),
  updateContact: ({ contactId, ...json }) => unwrap(contact.$patch({ param: { contactId }, json })),
  archiveContact: ({ contactId, version }) =>
    unwrap(contact.archive.$post({ param: { contactId }, json: { version } })),
  unarchiveContact: ({ contactId, version }) =>
    unwrap(contact.unarchive.$post({ param: { contactId }, json: { version } })),
  listAddresses: ({ organizationId, ...query }, signal) =>
    unwrap(party.addresses.$get({ query: { organizationId, ...filterQuery(query) } }, withSignal(signal))),
};
